function updateDataLayer(dataLayerValues) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    ecommerce: null
  });
  dataLayer.push(dataLayerValues);
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function updatePrice() {
  let prices = document.querySelectorAll('.product-form__submit .js-product-price');
  if (prices.length == 0) return;

  const productForm = document.querySelector('[data-type="add-to-cart-form"]');
  if (!productForm) return;

  let combinedPrice = parseFloat(productForm.dataset.activePrice);

  let currentQty = document.querySelector('.product-form__quantity .quantity__input').value;
  let calculatedPrice = combinedPrice * parseInt(currentQty) * 100;

  prices.forEach(price => {
    price.innerHTML = Shopify.formatMoney(calculatedPrice, window.money.format);
  });
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    updatePrice();
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-stmt-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      poster.classList.add('hidden');
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.progressBar = this.querySelector('.slider-progress-bar .slider-progress-bar__value');
    this.dots = this.querySelector('.slider-counter--dots');

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    if (!this.prevButton || !this.nextButton) return;
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.update();
  }

  resetPages(selector) {
    if (selector) {
      this.sliderItems = this.querySelectorAll('[class~="' + selector + '"]');
    } else {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    }
    this.slider.scrollTo({
      left: 0
    });
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.progressBar) {
      let valueWidth = 100 / this.totalPages;
      let marginLeft = valueWidth * (this.currentPage - 1) + "%";
      this.progressBar.style.width = valueWidth + "%";
      this.progressBar.style.marginLeft = marginLeft;
    }

    if (this.dots != null && this.dots !== undefined) {
      this.allDots = this.dots.querySelectorAll(".dot");

      if (!this.allDots.length) return;
      this.allDots.forEach((link) => {
        link.parentNode.classList.remove("slider-counter__link--active");
        link.removeAttribute("aria-current");
      });

      if (!this.allDots[this.currentPage - 1]) return;

      this.allDots[this.currentPage - 1].parentNode.classList.add("slider-counter__link--active");
      this.allDots[this.currentPage - 1].setAttribute("aria-current", true);
    }

    if (!this.nextButton) return;

    document.addEventListener('reinit-slider', () => {
      this.resetPages('slider__slide');
    });

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    if (this.enableSliderLooping) return;
  }

  isSlideVisible(element, offset = -10) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });

    // HotSpot Slider
    const hotspotContainer = event.currentTarget.parentNode.parentNode.parentNode;
    let allHotspots = hotspotContainer.querySelectorAll('.hotspot');
    let allSlides = []

    hotspotContainer.querySelectorAll('.hotspot__slider > ul > li').forEach((slide) => {
      allSlides.push(slide);
    })

    let currentSlide = ''

    this.sliderItemsToShow.forEach((slide) => {
      if (event.currentTarget.name === 'next') {
        if (this.isSlideVisible(slide)) {
          currentSlide = slide.nextElementSibling.dataset.slide
        }
      } else {
        if (this.isSlideVisible(slide)) {
          currentSlide = slide.previousElementSibling.dataset.slide
        }
      }
    })

    allHotspots.forEach((hotspot) => {
      if (hotspot.dataset.slide == currentSlide) {
        hotspot.classList.add('is-active');
      } else {
        hotspot.classList.remove('is-active');
      }
    });

    if (this.allDots == undefined || this.allDots == null) return;

    this.allDots.forEach((dot) => {
      if (dot.dataset.slide == currentSlide) {
        dot.parentNode.classList.add('slider-counter__link--active');
      } else {
        dot.parentNode.classList.remove('slider-counter__link--active');
      }
    })
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.toggleBIS();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateKlarna();
    this.synchroniseOptions();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.toggleBIS();
      this.updateKlarna();
    }

    // LLR-74 - reset personalisation text when switching variants
    const personalisationInput = document.querySelector('#personalisation');
    if (personalisationInput) {
      personalisationInput.value = '';
    }

    updatePrice();
    const priceUpdateEvent = new Event("priceUpdateEvent");
    document.dispatchEvent(priceUpdateEvent);
  }

  toggleBIS() {
    // let BISBtn = document.querySelector('.klaviyo-bis-trigger');
    let BISBtn = document.querySelector('#attn-waitlist-trigger');
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    let addButtons = productForm.querySelectorAll('[name="add"]');
    if (!addButtons) return;

    if (this.currentVariant && this.currentVariant.available) {
      addButtons.forEach(addButton => addButton.classList.remove('is-hidden'));
      if(BISBtn) {
        BISBtn.classList.add('is-hidden');
        BISBtn.classList.add('hidden');
      }
    } else {
      addButtons.forEach(addButton => addButton.classList.add('is-hidden'));
      if(BISBtn) {
        BISBtn.classList.remove('is-hidden');
        BISBtn.classList.remove('hidden');
      }
    }
  }

  updateKlarna() {
    if (this.currentVariant != undefined) {
      document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", this.currentVariant.price);
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
      if (window.Klarna && window.Klarna.OnsiteMessaging && typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
        window.Klarna.OnsiteMessaging.refresh();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);

    mediaGalleries.forEach((mediaGallery) => {
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
      }
    });

    const stickyImage = document.querySelector('sticky-add-to-cart .sticky-bar__item--image img');
    if (stickyImage) stickyImage.src = this.currentVariant.featured_media.preview_image.src;

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;

    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const type = option.querySelector('.form__label').innerHTML;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue, type);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions, type) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerHTML = `<span>${type}</span> ${input.getAttribute('value')}`;
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {

    const requestedVariantId = this.currentVariant.id;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const optionSource = html.querySelectorAll(`[class^=option-value-${this.dataset.product}]`);
        const optionDestination = document.querySelectorAll(`[class^=option-value-${this.dataset.product}]`);

        const preorderSource = html.querySelectorAll(`[class^=variant-pre-order-${this.dataset.product}]`);
        const preorderDestination = document.querySelectorAll(`[class^=variant-pre-order-${this.dataset.product}]`);

        if (preorderSource && preorderDestination) {
          preorderSource.forEach((source, index) => {
            if (preorderDestination[index] && source) {
              preorderDestination[index].innerHTML = source.innerHTML
            }
          });
        }

        if (optionSource && optionDestination) {
          optionSource.forEach((source, index) => {
            if (optionDestination[index]) {
              optionDestination[index].innerHTML = source.innerHTML
            }
          });
        }

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, true, this.currentVariant);

      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, currentVariant) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const personalisationYes = document.querySelector("#personalisation-yes");
    if (!productForm) return;
    let addButtons = productForm.querySelectorAll('[name="add"]');
    let addButtonText = productForm.querySelectorAll('[name="add"] > span');
    if (!addButtons) return;


    let finalPrice;

    if (personalisationYes) {
      if (personalisationYes.checked == true) {
        disable = true;
      }
    }

    if (document.getElementById(`price-${this.dataset.section}`)) {
      finalPrice = document.getElementById(`price-${this.dataset.section}`).querySelector('.price__container .price__regular .price-item');
      finalPrice = `<span class="js-product-price quick-add-hidden" data-price="${finalPrice.dataset.price}">${finalPrice.innerHTML}</span>`;
    }

    addButtons.forEach(addButton => addButton.removeAttribute('disabled'));

    if (finalPrice) {
      addButtonText.forEach(addText => addText.innerHTML = window.variantStrings.addToCart + '<span class="quick-add-hidden">|</span>' + finalPrice);
    } else {
      addButtonText.forEach(addText => addText.innerHTML = window.variantStrings.addToCart);
    }


    if (currentVariant && currentVariant.preorder == true) {
      if (finalPrice) {
        addButtonText.forEach(addText => addText.innerHTML = window.variantStrings.preorder + '<span class="quick-add-hidden">|</span>' + finalPrice);
      } else {
        addButtonText.forEach(addText => addText.innerHTML = window.variantStrings.preorder);
      }
    }
    else {
      if (finalPrice) {
        addButtonText.forEach(addText => addText.innerHTML = window.variantStrings.addToCart + '<span class="quick-add-hidden">|</span>' + finalPrice);
      } else {
        addButtonText.forEach(addText => addText.innerHTML = window.variantStrings.addToCart);
      }
    }

    if (disable) {
      addButtons.forEach(addButton => addButton.setAttribute('disabled', 'disabled'));
    }

    const subsciptionPrice = document.querySelector('.subscriptions__tabs #one-time');
    if (subsciptionPrice) subsciptionPrice.innerHTML = window.productStrings.one_time + finalPrice;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    let addButtons = button.querySelectorAll('[name="add"]');
    let addButtonText = button.querySelectorAll('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButtons) return;

    addButtonText.forEach(addText => addText.textContent = window.variantStrings.unavailable);

    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('.js-variant-data').textContent);
    return this.variantData;
  }

  synchroniseOptions() {
    const productVariants = document.querySelector('.product variant-radios');
    const productVariantOptions = productVariants.querySelectorAll('fieldset');

    productVariantOptions.forEach((option, idx) => {
      option.querySelector(`input[value="${this.options[idx]}"]`).click();
    });
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  synchroniseOptions() {
    const stickyVariants = document.querySelector('sticky-add-to-cart variant-selects');
    const stickyVariantOptions = stickyVariants.querySelectorAll('select');

    if (stickyVariantOptions) {
      stickyVariantOptions.forEach((option, idx) => option.value = this.options[idx]);
      stickyVariants.dispatchEvent(new Event('change'));
    }
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          document.dispatchEvent(new CustomEvent('reload-trustpilot', {
            detail: {
              parent: this
            }
          }));
          
          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// Accordions
class Accordion extends HTMLElement {
  constructor() {
    super();
    this.listeners();
    this.resizeChecker();
  }

  listeners() {
    let accordions = document.querySelectorAll("accordion-wrapper");

    // Bind click events for each accordion
    accordions.forEach((el) => {
      // Data attributes passed through the accordion
      let accordionHeaders = el.querySelectorAll(".accordion__header");
      let openFirstItem =
        el.getAttribute("data-open-first") == "true" ? true : false;

      // Open first accordion item on load
      if (openFirstItem === true) {
        let firstItem = el.querySelector(".accordion__item");
        this.openFirstItem(firstItem);
      }

      accordionHeaders.forEach((el) => {
        el.addEventListener("click", this.accordionClickEvent);
      });
    });

    // Add window listener for checking accordion states
    window.addEventListener("resize", debounce(this.resizeChecker, 200));
  }

  // Open all accordions above threshold, close below threshold
  resizeChecker() {
    let accordions = document.querySelectorAll("accordion-wrapper");

    accordions.forEach((el) => {
      let mobileOnly =
        el.getAttribute("data-mobile-only") == "true" ? true : false;
      let openFirstItem =
        el.getAttribute("data-open-first") == "true" ? true : false;

      if (mobileOnly) {

        const mediaQuery = window.matchMedia(
          "(max-width:" + window.mediaStrings.mobileSmall + ")"
        );

        let accordionItems = el.querySelectorAll(".accordion__item");
        if (mediaQuery.matches) {
          accordionItems.forEach((el) => {
            el.classList.remove("is-open");
          });
        } else {
          accordionItems.forEach((el) => {
            el.classList.add("is-open");
          });
        }
      }

      // If attribute set, open first item in accordion
      if (openFirstItem === true) {
        let firstItem = el.querySelector(".accordion__item");
        firstItem.classList.contains("is-open")
          ? null
          : firstItem.classList.add("is-open");
      }
    });
  }

  // Open the first item in accordion if data attribute has been set
  openFirstItem(el) {
    el.classList.contains("is-open") ? null : el.classList.add("is-open");
  }

  // Accordion click event to determine if it's mobile only
  accordionClickEvent() {
    // When opening each accordion, bind configuration values for given accordion
    let el = this;
    let accordionItem = el.parentNode;
    let accordionContainer = el.parentNode.parentNode;
    let mobileOnly =
      accordionContainer.getAttribute("data-mobile-only") == "true"
        ? true
        : false;

    const mediaQuery = window.matchMedia(
      "(max-width:" + window.mediaStrings.mobileSmall + ")"
    );

    if (mobileOnly) {
      if (mediaQuery.matches) {
        Accordion.toggleStates(accordionContainer, accordionItem);
      }
    } else {
      Accordion.toggleStates(accordionContainer, accordionItem);
    }
  }

  // Toggle active states of clicked accordion
  static toggleStates(container, item) {
    let accordionItem = item;
    let accordionItems = container.querySelectorAll(".accordion__item");
    let autoClose =
      container.getAttribute("data-auto-close") == "true" ? true : false;

    if (!accordionItem.classList.contains("is-open")) {
      // Close all accordions if auto-close is enabled
      if (autoClose === true) {
        accordionItems.forEach((el) => {
          el.classList.contains("is-open")
            ? el.classList.remove("is-open")
            : null;
        });
      }

      // Open selected accordion item
      accordionItem.classList.add("is-open");
    } else {
      // Close selected accordion item
      accordionItem.classList.remove("is-open");
    }
  }
}

customElements.define("accordion-wrapper", Accordion);

function getSectionsToRender() {

  if (document.getElementById('stmt-main-cart-items')) {
    return [
      {
        id: 'stmt-main-cart-items',
        section: document.getElementById('stmt-main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'stmt-sticky-checkout',
        section: document.getElementById('stmt-sticky-checkout').dataset.id,
        selector: '.js-contents'
      }
    ];
  } else {
    return [
      {
        id: 'CartDrawer',
        section: 'stmt-cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

// Genric Read More
document.querySelectorAll('.read-toggle').forEach(truncatedText => {
  truncatedText.addEventListener("click", (event) => {
    let div = event.target.closest('div');
    div.classList.add('hidden');
    if (event.target.classList.contains('read-more')) {
      div.nextElementSibling.classList.remove('hidden');
    } else {
      div.previousElementSibling.classList.remove('hidden');
    }
  })
})

// Featured Collection 
class FeaturedCollection extends HTMLElement {

  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    // Featured Collection
    let navItems = this.querySelectorAll('.featured-collection__nav > .featured-collection__button');
    let productsToShow = this.querySelector('.featured-collection__nav').dataset.productsToShow;

    navItems.forEach((link) => link.addEventListener("click", (event) => {

      let currentCollectionSlider = event.target.closest('featured-collection');

      let featuredCollection = [],
        featuredCollectionName = link.innerText;

      link.classList.add('is-active');

      navItems.forEach((inactiveLink) => {
        if (inactiveLink != link) {
          inactiveLink.classList.remove('is-active');
        }
      });

      let buttonText = link.dataset.buttonText;
      let buttonLink = link.dataset.collection;

      fetch('/collections/' + link.dataset.collection + '/products.json?limit=' + productsToShow)
        .then((response) => response.json())
        .then(data => {

          data.products.forEach((product) => {
            featuredCollection.push(product);
          });

          const featuredCollectionList = this.querySelector('.js-featured-collection');

          this.querySelector('.animated-loader-overlay').classList.remove('hidden');

          const requests = [];

          featuredCollection.forEach((product) => {
            requests.push(fetch(`/products/${product.handle}?section_id=stmt-card-product`));
          });

          Promise.all(
            requests
          ).then((responses) => {
            return Promise.all(responses.map((response) => {
              return response.text();
            }));
          }).then((products) => {
            featuredCollectionList.innerHTML = ''

            products.forEach((product) => {
              const parser = new DOMParser();
              const productHtml = parser.parseFromString(product, "text/html");
              const card = productHtml.querySelector('.js-card');
              const productAvailability = card.querySelector('.card').dataset.productStatus;

              if (featuredCollectionList && card) {
                if (productAvailability === 'true') {
                  featuredCollectionList.innerHTML += `
                    <li class="grid__item slider__slide">
                      ${card.innerHTML}
                    </li>
                  `
                }
              }
            });

            this.querySelector('.animated-loader-overlay').classList.add('hidden');
            document.dispatchEvent(new Event('reinit-slider'));

            if (currentCollectionSlider.querySelector('.collection__view-all .button') !== null) {
              currentCollectionSlider.querySelector('.collection__view-all .button').textContent = buttonText.trim();
              currentCollectionSlider.querySelector('.collection__view-all .button').href = '/collections/' + buttonLink;
            }

            if (featuredCollectionList) {
              document.dispatchEvent(new CustomEvent('reload-trustpilot', {
                detail: { parent: featuredCollectionList }
              }));
            }
          })
            .catch((error) => console.error(error));
        })
    })
    );
  }
}

customElements.define('featured-collection', FeaturedCollection);

class Excerpt extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    let excerpts = document.querySelectorAll(".js-excerpt");


    excerpts.forEach((excerpt) => {
      let readMore = this.querySelector('.rich-text__button--more');
      let readLess = this.querySelector('.rich-text__button--less');
      if (readMore) {
        readMore.addEventListener('click', event => {
          event.preventDefault();

          this.classList.add('rich-text__content--expand');
        });

        readLess.addEventListener('click', event => {
          event.preventDefault();

          this.classList.remove('rich-text__content--expand');
        });
      }
    })
  }
}

customElements.define('excerpt-component', Excerpt);

class FakeVariants extends HTMLElement {

  constructor() {
    super();
    this.handler();
  }

  handler() {
    this.dataObject = JSON.parse(this.querySelector('.js-fake-variants').textContent);
    this.variants = this.dataObject.variants;

    if (this.variants.length) this.getSwatches();
  }

  getSwatches() {
    const requests = [];

    this.variants.forEach(handle => {
      requests.push(fetch(`/products/${handle}`));
    });

    Promise.all(requests)
      .then(responses => Promise.all(responses.map(response => response.text())))
      .then(products => products.forEach((product, index) => this.addSwatches(product, index)))
      .catch((error) => console.error(error));
  }

  addSwatches(product, idx) {
    const parser = new DOMParser();
    const productHtml = parser.parseFromString(product, "text/html");
    const variantData = productHtml.querySelector('.js-fake-variants');
    const swatches = document.querySelector('.js-swatches');
    const variant = JSON.parse(variantData.textContent).swatch;
    const type = this.dataObject.type;
    const url = `/products/${this.variants[idx]}`;
    if (variant) {
      if (type === "swatch") {
        const variant_id = 'variant_' + variant.name.toLowerCase().split(' ').join('');
        const swatch = document.createElement("a");

        // Create Swatch
        swatch.href = url;
        swatch.id = variant_id;
        swatch.dataset.variant = variant.name;
        swatch.classList.add('product__swatch');
        swatch.style.background = variant.image ? 'url(' + variant.image + ')' : variant.colour;

        // Add Event Listener to Swatch if Quick View
        const isQuickAdd = this.closest("quick-add-modal");
        if (isQuickAdd !== null) {
          swatch.addEventListener('click', (e) => {
            e.preventDefault();

            isQuickAdd.dispatchEvent(new CustomEvent('reload-quick-add', {
              detail: { url }
            }));
          })
        }

        // Add Swatch to Container
        swatches.appendChild(swatch);
      }

      if (type === "dropdown") {
        const select = swatches.querySelector('.select__select');
        const option = new Option(variant.name, variant.name);

        if (select.getAttribute('has-listener') !== 'true') {
          select.setAttribute('has-listener', 'true');
          select.addEventListener('change', event => {
            event.preventDefault();

            if (event.target.value === variant.name) window.location = url;
          });
        }

        select.add(option, undefined);
      }
    }
  }
}

customElements.define('fake-variants', FakeVariants);

// Reload Trustpilot widgets
document.addEventListener('reload-trustpilot', (event) => {
  let parent = event.detail.parent;
  let tpWidgets = parent.querySelectorAll('.trustpilot-widget');
  tpWidgets.forEach((widget) => {
    window.Trustpilot.loadFromElement(widget);
  })
});

function disableProductCTA(state) {
  const submitCTAs = document.querySelectorAll('.product-form__submit');

  submitCTAs.forEach(cta => {
    cta.disabled = !!state
  });
}

document.addEventListener('load-swatches', function () {
  const allSwatches = document.querySelectorAll('.js-card-swatch');

  allSwatches.forEach(swatch => {
    const handle = swatch.dataset.handle;
    fetch('/products/' + handle).then(response => response.text()).then(text => {
      const variantData = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('.js-fake-variants');
      const swatchData = JSON.parse(variantData.textContent).swatch;
      const swatchBg = swatchData.image ? 'url(' + swatchData.image + ')' : swatchData.colour;
      swatch.style.background = swatchBg;
    });
  });

  const realVariantSwatches = document.querySelectorAll('.js-card-real-swatch');

  realVariantSwatches.forEach(swatch => {
    const handle = swatch.dataset.handle;
    fetch('/products/' + handle).then(response => response.text()).then(text => {
      const variantData = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('.js-real-variants');

      const swatchData = JSON.parse(variantData.textContent).swatches;
      let swatchElements = '';
      const limit = 4;
      swatchData.slice(0, limit).forEach((item) => {
        swatchElements += `<a href="/products/${handle}?variant=${item.id}" class="js-card-swatch product__swatch--collection" style="background:${item.style}""></a>`
      })

      if (swatchData.length > limit) {
        swatchElements += `<a href="/products/${handle}" class="product__swatch--plus"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></svg></a>`
      }
      swatch.innerHTML = swatchElements;
    });
  });

});

document.addEventListener('DOMContentLoaded', function () {
  const searchIcon = document.querySelector('.js-icon-search');
  const searchForm = document.querySelector('.header__mobile-search');

  if (searchForm && searchIcon) {
    searchIcon.addEventListener('click', function () {
      searchForm.classList.toggle('small-hide');
    });
  }
});